import { create } from "zustand";
import { DISTANCE_PBO } from "../Utils/constant";
import { find } from "../services/service";
export const useConfigStore = create((set) => ({
  loading: false,
  data: [],
  distancePBO: [],
  getDistancePBO: async () => {
    set({
      loading: true,
      distancePBO: [],
    });

    try {
      const getItems = await find(`${DISTANCE_PBO}`);
      set({
        loading: false,
        distancePBO: getItems.data,
      });
    } catch (error) {
      set({
        loading: true,
        distancePBO: [],
      });
    }
  },
  getData: async (url) => {
    set({
      loading: true,
      data: [],
    });

    try {
      const getItems = await find(url);
      set({
        loading: false,
        data: getItems.data,
      });
    } catch (error) {
      set({
        loading: true,
        data: [],
      });
    }
  },
}));
